import React, { Component, Suspense } from "react";
import { Route, Switch } from "react-router";
import defaultRoutes from "erp/routes/index";
import PrivateRoute from "./common/PrivateRoute";
import NotificationContainer from "./erp/components/NotificationContainer";

export class App extends Component {

    constructor(props, ctx) {
        super(props, ctx);
    }

    render() {
        return (
            <React.Fragment>
                <Suspense fallback={<span>Loading...</span>}>
                    <Switch>
                        {defaultRoutes.map((prop, key) => prop.isPrivate
                            ? <PrivateRoute path={prop.path} component={prop.component} key={key} />
                            : <Route path={prop.path} component={prop.component} key={key} />)}
                    </Switch>
                </Suspense>
                <NotificationContainer />
            </React.Fragment>
            );
    }
}


// WEBPACK FOOTER //
// ./src/App.js